<template>
    <div class="components-container">
        <div class="filter-container">
            <el-select v-model="queryForm.auditState" filterable placeholder="审核状态" style="width:300px;">
                <el-option v-for="item in comboData.auditState" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-button @click="handleFilter" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
            <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
        </div>

        <el-table :data="tableData" v-loading.body="tableLoading" :cell-style="handleCellStyle"
            element-loading-text="信息加载中" highlight-current-row border style="width: 100%" :height="mainTableHeight" ref="mainTable">
            <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                    <span>{{ (currentPage - 1) * limit + scope.$index + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column label="学年" prop="year" align="center" min-width="25%"></el-table-column>
            <el-table-column label="毕业标准类型" prop="standardType" :formatter="standardTypeFormatter" align="center" min-width="20%"></el-table-column>
            <el-table-column label="毕业标准" prop="standardRatio" :formatter="standardRatioFormatter" align="center" min-width="20%"></el-table-column>
            <el-table-column label="提交状态" prop="submitState" :formatter="submitStateFormatter" align="center" min-width="15%"></el-table-column>
            <el-table-column label="审核状态" prop="auditState" :formatter="auditStateFormatter" align="center" min-width="15%"></el-table-column>
            <el-table-column label="操作" align="center" min-width="25%">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.submitState == '0'" size="small" @click="showGraduateStuList('set', scope.row);" type="warning">
                        <i class="el-icon-tickets"></i>&nbsp;学生名单
                    </el-button>
                    <el-button v-if="scope.row.submitState=='1' && scope.row.auditAuth=='0'" size="small" @click="showGraduateStuList('view', scope.row);" type="warning">
                        <i class="el-icon-tickets"></i>&nbsp;学生名单
                    </el-button>
                    <el-button v-if="scope.row.auditAuth == '1'" size="small" @click="showGraduateStuList('audit', scope.row);" type="primary">
                        <i class="el-icon-edit-outline"></i>&nbsp;审核
                    </el-button>
                    <el-button v-if="scope.row.submitState=='1' || scope.row.auditState!=''" size="small" @click="showAuditList(scope.row);">
                        <i class="el-icon-document"></i>&nbsp;审核信息
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange" :current-page.sync="currentPage"
                :page-sizes="[10, 20, 50]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" v-if="dialogVisible" width="1500px" :top="dialogTop">
            <div style="height:700px;">
                <graduateStu ref="graduateStu" :graduateParam="graduateParam" @closeDialog="closeDialog" @updateDialogTitle="updateDialogTitle"></graduateStu>
            </div>
        </el-dialog>

        <el-dialog title="审核信息" :visible.sync="auditListDialogVisible" v-if="auditListDialogVisible" width="900px" top="150px">
            <div style="height:550px;">
                <auditList ref="auditList" :relatedCode="graduateParam.mainCode" :listHeight="450" :auditFlowInfo="auditFlowInfo"></auditList>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import graduateStu from 'views/baseInfo/student/graduateStu.vue';
    import auditList from 'views/audit/auditList.vue';

    export default {
        components: {
            graduateStu,
            auditList,
        },
        data() {
            return {
                comboData: {
                    auditState: null,
                },
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    auditState: null,
                    itemCode: null,
                },
                tableData: [],
                currentPage: 1,
                limit: 10,
                total: null,
                tableLoading: true,
                mainTableHeight: 500,
                dialogTitle: '',
                dialogTop: '50px',
                dialogVisible: false,
                graduateParam: {
                    openType: 'view',
                    mainCode: null,
                    year: null,
                    standardType: null,
                    standardRatio: null,
                    auditParam: null,
                    auditLevel: null,
                },
                auditListDialogVisible: false,
                auditFlowInfo: null,
            };
        },
        created(){
            this.initGraduateYearInfo();
        },
        mounted() {
            this.initCombo();
            this.queryAuditParam();

            this.$nextTick().then(() => {
                //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
                //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
                this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;

                // 监听窗口大小变化
                let self = this;
                window.onresize = function() {
                    self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
                };
            });
        },
        methods: {
            //初始化毕业学年信息
            initGraduateYearInfo(){
                this.$api.student.graduate.init();
            },
            //查询审核调用参数
            queryAuditParam(){
                const pageName = this.$route.path.substring(this.$route.path.lastIndexOf("/")+1);

                this.$api.common.audit.auditParam({
                    data: { pageName: pageName },
                }).then((res) => {
                    this.graduateParam.auditParam = res.data.data.auditParam;
                    this.queryForm.itemCode = res.data.data.auditParam;
                    this.queryList();
                }).catch((err) => {
                    console.log(err);
                });
            },
            standardTypeFormatter(row){
                let str = row.standardType;

                if(row.standardType !== ''){
                    str = row.standardType === '01' ? '成绩达标' : '学分达标';
                }
                return str;
            },
            standardRatioFormatter(row){
                let str = row.standardRatio;

                if(str){
                    if(row.standardType === '02'){
                        str = '获得学分';
                    }else{
                        str = '合格科目';
                    }
                    str += '达到 ' + row.standardRatio + ' %';
                }
                return str;
            },
            submitStateFormatter(row){
                return row.submitState === '1' ? '已提交' : '未提交';
            },
            auditStateFormatter(row){
                let str = '';

                if(row.auditState==='1'){
                    str = '通过';
                }else if(row.auditState==='2'){
                    str = '驳回';
                }else{
                   if(row.submitState === '1'){
                       if(row.auditLevel === '1'){
                           str = '待审核';
                       }else{
                           str = '审核中';
                       }
                   }else{
                       str = '未提交';
                   }
                }

                return str;
            },
            handleCellStyle({row, column, rowIndex, columnIndex}){
                let cellStyle;

                if(columnIndex === 5){
                    switch (row.auditState) {
                        case '1':
                            cellStyle = 'color: #00FF40 !important;';
                            break;
                        case '2':
                            cellStyle = 'color: #FE2E2E !important;';
                            break;
                        default:
                            cellStyle = '';
                    }

                    return cellStyle;
                }
            },
            queryList() {
                this.tableLoading = true;
                this.queryForm.pageNum = this.currentPage;
                this.queryForm.rowNum = this.limit;

                this.$api.student.graduate.yearList({
                    data: this.queryForm,
                }).then((response) => {
                    this.total = response.data.data.total;
                    this.tableData = response.data.data.list;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            handleFilter() {
                this.currentPage = 1;
                this.queryList();
            },
            handleReset() {
                this.limit = 10;
                this.currentPage = 1;
                this.queryForm.auditState = null;
                this.tableLoading = false;
                this.queryList();
            },
            handlePageChange(val) {
                this.currentPage = val;
                this.queryList();
            },
            handleSizeChange(val) {
                this.limit = val;
                this.currentPage = 1;
                this.queryList();
            },
            initCombo() {
                this.$api.common.comboOption.auditState({}).then((res) => {
                    this.comboData.auditState = res.data.data.comboData;
                }).catch((err) => {
                    console.log(err);
                });
            },
            showGraduateStuList(type, rowData){
                this.graduateParam.openType = type;
                this.graduateParam.mainCode = rowData.id;
                this.graduateParam.year = rowData.year;
                this.graduateParam.standardType = rowData.standardType;
                this.graduateParam.standardRatio = rowData.standardRatio;
                this.dialogTitle = rowData.year + '学年';

                if(type == 'set'){
                    this.dialogTitle += '毕业学生设置';
                    //this.detailDialogTop = '250px';
                }else if(type == 'audit'){
                    this.dialogTitle += '毕业学生审核';
                    this.graduateParam.auditLevel = rowData.auditLevel;
                }else{
                    this.dialogTitle += '毕业学生名单';
                }

                if(rowData.standardType != ''){
                    const tempTypeStr = rowData.standardType=='02'?'学分达标':'成绩达标';
                    const tempRatioStr = rowData.standardType=='02'?'获得学分':'合格科目';
                    this.dialogTitle += '  『 毕业标准：' + tempTypeStr + ' - ' + tempRatioStr + '达到 ' + rowData.standardRatio + ' % 』';
                }

                this.dialogVisible = true;
            },
            updateDialogTitle(titleStr){
                this.dialogTitle = titleStr;
                this.queryList();
            },
            closeDialog() {
                this.dialogVisible = false;
                this.queryList();
            },
            showAuditList(rowData){
                this.$api.student.graduate.queryAuditFlow({
                    data: {
                        itemCode: this.queryForm.itemCode,
                        relatedCode: rowData.id,
                        auditState: rowData.auditState,
                        auditLevel: rowData.auditLevel,
                    },
                }).then((res) => {
                    if (res.data.data.state == 'success') {
                        this.auditFlowInfo = res.data.data.auditFlowInfo;
                    }else{
                        this.auditFlowInfo = null;
                    }

                    this.graduateParam.mainCode = rowData.id;
                    this.auditListDialogVisible = true;
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
        },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// graduate.vue?e2d95558